// extracted by mini-css-extract-plugin
module.exports = {"active":"Navigation_active__3WXsP","menuItem":"Navigation_menuItem__2AWiG"};